<template>
  <div>
    <transition name="nav-push-top">
      <nav class="primary-bg-color" ref="navbar">
        <img :src="require('../assets/logos/logo_1.png')" class="logo" @click="$router.push('/')" />
        <img class="burger" :src="require('../assets/icons/menu.png')" @click="collapse=!collapse" />
        <transition name="slide">
          <ul ref="items" class="small primary-bg-color" :key="collapse" v-if="collapse">
            <li v-for="item in menuItems" :key="item.id">
              <router-link :to="item.url">{{item.name}}</router-link>
            </li>
          </ul>
        </transition>
        <ul class="big">
          <li v-for="item in menuItems" :key="item.id">
            <router-link :to="item.url">{{item.name}}</router-link>
          </li>
        </ul>
      </nav>
    </transition>
  </div>
</template>

<script>
import ScrollBtn from "@/components/ScrollBtn.vue";

export default {
  components: {
    ScrollBtn
  },
  data() {
    return {
      currentPosition: 0,
      lastPosition: 0,
      collapse: false,
      menuItems: [
        { id: 1, name: "Start", url: "/start" },
        { id: 2, name: "Projekt", url: "/projekt" },
        // { id: 3, name: "Mach Mit!", url: "/machmit" },
        // { id: 4, name: "Auswertung", url: "/auswertung" },
        { id: 5, name: "Aktuelles", url: "/aktuelles" }
      ]
    };
  },
  mounted() {
    // console.log(navigator.appName);
  },
  methods: {
    checkBrowser() {},
    onResize() {
      if (window.innerWidth >= 1200) {
        if (window.scrollY > 100) {
          this.$refs.navbar.style.marginTop = "0";
        } else {
          this.$refs.navbar.style.marginTop = "50px";
        }
      } else {
        this.$refs.navbar.style.marginTop = "0";
      }
    },
    onScroll() {
      // this.collapse = false;
      this.currentPosition = window.scrollY;

      // beim runterscrollen
      if (this.currentPosition > this.lastPosition) {
        if (window.scrollY > 100) {
          // this.$refs.navbar.style.opacity = 0.9;
          this.$refs.navbar.style.marginTop = 0;
        } else {
          // this.$refs.navbar.style.opacity = 1;
          // this.$refs.scrollBtn.style.opacity = 0;
        }

        // beim hochscrollen
      } else {
        if (window.scrollY < 150) {
          // this.$refs.navbar.style.opacity = "1";
          if (window.innerWidth >= 1200) {
            this.$refs.navbar.style.marginTop = "50px";
          }
        } else {
          // this.$refs.navbar.style.opacity = "0.9";
        }
      }
      this.lastPosition = window.scrollY;
    },
    onClick(e) {
      if (this.$refs.navbar.contains(e.target)) {
      } else {
        this.collapse = false;
      }
    },
    scrollTop() {
      window.scrollTo(0, 0);
    }
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("click", this.onClick);
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("click", this.onClick);
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    $route(to, from) {
      this.collapse = false;
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

nav {
  z-index: 1111;
  height: 100px;
  // Nav durchsichtig wenn runtergescrollt
  // opacity: 0.9;
  // transition: opacity 1s;
  transition: margin-top 0.2s ease-out;
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  img {
    cursor: pointer;
  }
  .logo {
    height: 100%;
    z-index: 1111;
  }
  .burger {
    height: 60%;
    margin: 15px;
  }
  ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
    li {
      a {
        color: white;
        text-decoration: none;
      }
    }
  }
}

.small {
  position: fixed;
  right: 0;
  width: 100%;
  top: 100px;
  flex-direction: column;
  align-items: flex-end;
  padding: 20px;
  li {
    text-decoration: none;
    margin: 10px;
    a {
      padding: 5px;
      color: white;
      text-decoration: none;
      &.router-link-active {
        color: rgb(155, 155, 155);
      }
      &:hover {
        color: rgb(209, 209, 209);
        font-weight: normal;
      }
    }
  }
}
.big {
  display: none;
  width: auto;
  li {
    a {
      margin: 5px 0;
      padding: 15px 0;
      color: white;
      margin-left: 20px;
      transition: border 0.3s;

      &.router-link-active {
        border-top: 5px solid white;
      }
      &:hover {
        border-top: 5px solid white;
        font-weight: normal;
      }
    }
  }
}

@media (min-width: 1200px) {
  nav {
    margin-top: 50px;
    align-items: center;
    height: 150px;
    padding: 30px;
    .burger {
      display: none;
    }
    ul {
      &.small {
        display: none;
      }
      &.big {
        display: flex;
      }
    }
  }
}
@media (min-width: 1200px) {
  nav {
    left: calc((100% - 1200px) / 2);
    right: calc((100% - 1200px) / 2);
  }
}

// Navbar Collapse Slide Transition
.slide-enter-active {
  animation: slide-in 0.5s ease-out;
}
.slide-leave-active {
  // animation: slide-out 0 ease-out;
  animation: slide-out 0.3s;
}
@keyframes slide-in {
  0% {
    transform: translateY(-300px);
  }
  // 45% {
  //   transform: translateY(-150px);
  // }
  100% {
    transform: translateY(0);
  }
}
@keyframes slide-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

// Nur bei IE 10+
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .nav {
    top: 0 !important;
  }
}
// Nur bei Edge
// @supports (-ms-ime-align: auto) {
//   .nav {
//     top: 0;
//   }
// }
</style>